import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled('div')``;

export const Card = styled(Stack)`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${(p) => p.theme.spacing(3)};
`;

export const UploadWrapper = styled('div')`
  justify-self: flex-end;
`;
